import type { FaireProductEntity } from "../../entity_types/product";

export const p_d5rhvupy: FaireProductEntity = {
  token: "p_d5rhvupy",
  type: "product",
  name: "DEWDROP necklace - freshwater keshi",
  brandName: "Komakai Jewelry",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/411490e4175c2ea0f94f1f01759ed2f374c1784326fcb04effd32e6003bdbef7/1540010224.jpg",
  priceDollars: 36,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/4ecba908abd6e13e6e7d8d082add8a5e960759e5291c0079ed55bb5de0b07cd5/1558740443.jpg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
